$(document).ready(function() {



  // Initialize first Slick slider

  $('#shopify-section-template--22687900434708__image_with_text_column_MJdAct .image-2-main').slick({
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3.1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  setTimeout(function() {
    console.log('Run');
    document.querySelectorAll('.quick-add-button').forEach(function(button) {
      button.addEventListener('click', function(event) {
        var productId = event.target.getAttribute('data-product-id');
        addToCart(productId);
      });
    });
    document.querySelectorAll('.quick-add-buttona').forEach(function(button) {
      button.addEventListener('click', function(event) {
        var productId = event.target.getAttribute('data-product-id');
        addToCart(productId);
      });
    });
    document.querySelectorAll('.quick-add-buttonrel').forEach(function(button) {
      button.addEventListener('click', function(event) {
        var productId = event.target.getAttribute('data-product-id');
        addToCart(productId);
      });
    });
  }, 2500);

  

  function addToCart(productId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: productId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
                  .then((response) => response.text())
                  .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, "text/html");
                      const selectors = ["cart-drawer", ".cart-drawer__footer"];
                      for (const selector of selectors) {
                          const targetElement = document.querySelector(selector);
                          const sourceElement = html.querySelector(selector);
                          if (targetElement && sourceElement) {
                              targetElement.replaceWith(sourceElement);
                          }
                      }
                    document.querySelector('cart-drawer').open();
                  })
                  .catch((e) => {
                      console.error(e);
                  });
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }



});
